import { GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import type * as React from 'react'

import type { MetricCardProps } from '../types'
import { useLaunchpadContext } from '../context'

/**
 * A reusable card component for displaying metric information with actions
 */
export function MetricCard({ title, amount, metrics, isOpen = false }: MetricCardProps) {
  const { costRevenue } = useLaunchpadContext()
  return (
    <Horizontal
      bg='default'
      border='all'
      borderRadius='6px'
      className='p-3'
      flex='0'
      gap={24}
      style={{ overflow: 'visible' }}
      verticalCenter
    >
      <Vertical>
        <Texto appearance='hint'>{title}</Texto>
        <Texto category='h3' weight='bold' appearance={isOpen ? 'secondary' : 'primary'}>
          {amount}
        </Texto>
      </Vertical>
      <Vertical justifyContent='flex-end' alignItems='flex-end'>
        {metrics.map((metric) => (
          <Tooltip key={`${metric.type}-${metric.status}`} title={metric.linkLabel}>
            <GraviButton
              appearance='link'
              size='small'
              theme2
              style={{ lineHeight: '1.2' }}
              onClick={() => {
                if (metric.type === 'freight_line_items') {
                  window.open(
                    `freight_line_items?status=${metric.status}&costRevenue=${costRevenue}&view=byOrder`,
                    '_blank'
                  )
                } else if (metric.type === 'invoices') {
                  const today = new Date()
                  const thirtyDaysAgo = new Date()
                  thirtyDaysAgo.setDate(today.getDate() - 30)

                  const fromDate = thirtyDaysAgo.toISOString().split('T')[0]
                  const toDate = today.toISOString().split('T')[0]

                  window.open(
                    `invoices?status=${metric.status}&booktype=${costRevenue}&from_date=${fromDate}&to_date=${toDate}`,
                    '_blank'
                  )
                }
              }}
            >
              <Texto>{metric.label}</Texto>
              <Texto>→</Texto>
            </GraviButton>
          </Tooltip>
        ))}
      </Vertical>
    </Horizontal>
  )
}
